/// Port of mobile/lib/ui/pixel/pixel_button.dart.
///
/// Border and background are both surfaceContainerHighest, so the chrome reads
/// as a solid pixel-rounded chip rather than an outlined one.

import type { ReactNode } from 'react';

import { useThemeColors } from '@/settings/handler/settingsStore';
import { PixelContainer } from './PixelContainer';

export interface PixelButtonProps {
  icon: ReactNode;
  onClick: () => void;
  backgroundColor?: string;
  borderColor?: string;
  ariaLabel?: string;
  className?: string;
}

export function PixelButton({
  icon,
  onClick,
  backgroundColor,
  borderColor,
  ariaLabel,
  className,
}: PixelButtonProps) {
  const colors = useThemeColors();

  return (
    <PixelContainer
      // Grid cells (was radius 18 with pixelScale 2).
      radius={9}
      pixelScale={2}
      padding="0px"
      onClick={onClick}
      ariaLabel={ariaLabel}
      className={className}
      backgroundColor={backgroundColor ?? colors.surfaceContainerHighest}
      borderColor={borderColor ?? colors.surfaceContainerHighest}
    >
      {icon}
    </PixelContainer>
  );
}
